export const getAppOrigin = () => (typeof window !== "undefined" ? window.location.origin : "");

export const buildAppUrl = (path = "/") => `${getAppOrigin()}${path}`;